import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import SelectAsync from 'react-select/async';
import DatePicker from 'react-datepicker2';
//https://s-yadav.github.io/react-number-format/docs/numeric_format/
import NumberFormat from 'react-number-format';
import Person from "./Person";

export default class Remittance extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            io: props.IO,
            data: null,
            loading: true,
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/remittance/get", {
            id: this.getCurrentFormId(),
            io: this.state.io,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    window.organizationId = data.global.company.id;
                    this.state.data = data;
                    this.state.loading = false;
                    this.updateFormula();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e, withDocument=false) {
        if (!this.isNull(e)) e.preventDefault();
        if (this.isBlank(this.state.data.record.personMoein)) this.state.data.record.personMoein = 0;

        this.httpPost("api/v1/remittance/save", {
            withDocument: withDocument,
            organizationId: this.state.data.global.company.id,
            id: this.state.data.record.id,
            io: this.state.data.record.io,
            number: this.state.data.record.number,
            description: this.state.data.record.description,
            date: this.convertMomentToDb(this.state.data.record.date),
            personId: this.state.data.record.personId,
            type: this.state.data.record.type,
            personMoein: this.state.data.record.personMoein,
            warehouseId: this.state.data.record.warehouseId,
            warehouseId2: this.state.data.record.warehouseId2,
            bodies: this.state.data.bodies,
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {

                if (this.state.data.record.io == 2) {
                    this.showSuccessMessage("حواله انبار با شماره " + data.number + " با موفقیت ثبت شد.");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                if (this.state.data.record.io == 1) {
                    this.showSuccessMessage("رسید انبار با شماره " + data.number + " با موفقیت ثبت شد.");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    getBlankRow(defaultIndex = null) {
        return {
            id: this.uuidv4(),
            index: (defaultIndex == null ? this.state.data.bodies.length + 1 : defaultIndex),
            stuffId: this.defaultGuid(),
            stuffName: '',
            unitId: this.defaultGuid(),
            unitName: '',
            warehouseId: this.defaultGuid(),
            warehouseName: '',
            amount: 0,
            price: 0,
            total: 0,
        };
    }
    addBlankRow() {
        this.state.data.bodies.push(this.getBlankRow());
    }
    removeRow(id) {
        var temp = [];
        var index = 1;
        this.state.data.bodies.sort((a, b) => a.index - b.index).forEach(r => {
            if (r.id != id) {
                temp.push(r);
                temp[temp.length - 1].index = index;
                index++;
            }
        });
        this.state.data.bodies = temp;
        this.updateFormula();
    }
    copyRow(id) {
        var clone = null;
        this.state.data.bodies.forEach(i => {
            if (i.id === id) {
                clone = Object.assign({}, i);
            }
        });
        clone.id = this.uuidv4();
        var startIndex = clone.index;
        for (var i = 0; i < this.state.data.bodies.length; i++) {
            if (this.state.data.bodies[i].index > startIndex) this.state.data.bodies[i].index++;
        }
        clone.index++;
        this.state.data.bodies.push(clone);
        this.updateFormula();
    }
    upIndex(id) {
        var idIndex = -1;
        this.state.data.bodies.forEach((r, index) => {
            if (r.id == id) idIndex = index;
        });
        if (idIndex != -1 && idIndex > 0) {
            var ii = this.state.data.bodies[idIndex].index;
            this.state.data.bodies[idIndex].index = ii - 1;
            this.state.data.bodies[idIndex - 1].index = ii;
            this.setState({ data: this.state.data });
        }
    }
    downIndex(id) {
        var idIndex = -1;
        this.state.data.bodies.forEach((r, index) => {
            if (r.id == id) idIndex = index;
        });
        if (idIndex != -1 && idIndex < this.state.data.bodies.length - 1) {
            var ii = this.state.data.bodies[idIndex].index;
            this.state.data.bodies[idIndex].index = ii + 1;
            this.state.data.bodies[idIndex + 1].index = ii;
            this.setState({ data: this.state.data });
        }
    }
    setBodyValue(id, field, value) {
        for (var i = 0; i < this.state.data.bodies.length; i++) {
            if (this.state.data.bodies[i].id === id) {
                if (field == 'stuffId' || field == 'warehouseId' || field == 'unitId') {
                    if (field == 'stuffId') {
                        this.state.data.bodies[i][field] = value.value;
                        this.state.data.bodies[i]['count'] = 1;
                        this.state.data.bodies[i]['unitId'] = value.unitId;
                        this.state.data.bodies[i]['unitName'] = value.unitName;
                        this.state.data.bodies[i]['taxRate'] = value.taxRate;
                        this.state.data.bodies[i]['price'] = value.price;
                        this.state.data.bodies[i]["stuffName"] = value.label;
                    }
                    if (field == 'warehouseId') {
                        this.state.data.bodies[i][field] = value.value;
                        this.state.data.bodies[i]["warehouseName"] = value.label;
                    }
                    if (field == 'unitId') {
                        this.state.data.bodies[i][field] = value.value;
                        this.state.data.bodies[i]["unitName"] = value.label;
                    }
                }
                else {
                    this.state.data.bodies[i][field] = value;
                }

                if (this.isBlank(this.state.data.bodies[i]["amount"])) this.state.data.bodies[i]["amount"] = 0;
                if (this.isBlank(this.state.data.bodies[i]["price"])) this.state.data.bodies[i]["price"] = 0;
                if (this.isBlank(this.state.data.bodies[i]["total"])) this.state.data.bodies[i]["total"] = 0;

                if (field == 'stuffId') {
                    if (value != null) this.state.data.bodies[i]["unitId"] = value.unitId;
                    if (value != null) this.state.data.bodies[i]["price"] = value.price;
                }

                this.state.data.bodies[i]["total"] = this.FixedPointNumber(this.state.data.bodies[i]["price"] * this.state.data.bodies[i]["amount"]);
            }
        }
        this.updateFormula();
    }
    updateFormula() {
        var hasBlankRow = false;

        for (var i = 0; i < this.state.data.bodies.length; i++) {
            console.log(this.state.data.bodies[i].stuffId);
            if (this.state.data.bodies[i].stuffId == this.defaultGuid()) hasBlankRow = true;
        }

        if (!hasBlankRow) this.addBlankRow();

        this.setState({ date: this.state.data });
    }
    setPerson(e) {
        if (e.value == -1) {
            this.state.data.record.personId = this.defaultGuid();
            this.state.data.record.personName = '';
            this.showComponents({ component: <Person Caller={this} FromAutoComplete={true} /> });
            return;
        }
        this.state.data.record.personId = e.value;
        this.state.data.record.personName = e.label;
        this.setState({ data: this.state.data });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "width": "96%", "left": "7.125px", "top": "-2px" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="panel panel-info center-block" style={{ "max-width": "none", "border": "none" }} >
                            <div className="panel-heading">
                                <b>
                                    {this.state.data.record.io == 1 && <span>رسید انبار</span>}
                                    {this.state.data.record.io == 2 && <span>حواله انبار</span>}
                                </b>
                            </div>
                            <div className="panel-body">
                                <div className="row">
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="invoiceDate" className="title1">انبار <span className="red">*</span></label>
                                            <SelectAsync
                                                defaultValue={this.state.data.record.warehouseId != this.defaultGuid() ? [{ value: this.state.data.record.warehouseId, label: this.state.data.record.warehouseName }] : null}
                                                isMulti={false}
                                                placeholder="انتخاب انبار"
                                                defaultOptions
                                                loadOptions={this.loadWarehousesOptions}
                                                onChange={e => {
                                                    this.state.data.record.warehouseId = e.value
                                                    this.state.data.record.warehouseName = e.label
                                                }
                                                }
                                            />
                                        </div>
                                    </div>
                                    {/*{this.state.data.record.io == 1 &&*/}
                                    {/*    <div className="col-sm-3">*/}
                                    {/*        <div className="form-group">*/}
                                    {/*            <label for="invoiceDate" className="title1">معین طرف حساب <span className="red">*</span></label>*/}
                                    {/*            <SelectAsync*/}
                                    {/*                style={{ "width": "100%" }}*/}
                                    {/*                defaultValue={!this.isNull(this.state.data.record.personMoeinAccount) ? [{ value: this.state.data.record.personMoeinAccount.fullCode, label: this.state.data.record.personMoeinAccount.title }] : null}*/}
                                    {/*                isMulti={false}*/}
                                    {/*                placeholder="انتخاب معین طرف حساب"*/}
                                    {/*                defaultOptions*/}
                                    {/*                loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 3, 0)}*/}
                                    {/*                onChange={e => this.state.data.record.personMoein = e.value}*/}
                                    {/*            />*/}
                                    {/*        </div>*/}
                                    {/*    </div>*/}
                                    {/*}*/}
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            {this.state.io == 1 && <label for="invoiceContact" className="title1">تامین کننده<span className="red">*</span></label>}
                                            {this.state.io == 2 && <label for="invoiceContact" className="title1">مشتری<span className="red">*</span></label>}
                                            <div id="displayPersonBalance" style={{ "display": "inline-block" }} ></div>
                                            <SelectAsync
                                                value={this.state.data.record.personId != this.defaultGuid() ? [{ value: this.state.data.record.personId, label: this.state.data.record.personName }] : null}
                                                isMulti={false}
                                                placeholder="انتخاب ..."
                                                defaultOptions
                                                loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 1)}
                                                onChange={e => this.setPerson(e)}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-sm-3">
                                        <div className="row">
                                            {this.state.data.record.io === 1 && <div className="col-sm-4">
                                                <div className="form-group">
                                                    <label for="invoiceNumber" className="title1">نوع</label>
                                                    <select className="form-control text-center" defaultValue={this.state.data.record.type} onChange={e => this.state.data.record.type = parseInt(e.target.value)}>
                                                        <option value="1">خرید</option>
                                                        <option value="4">برگشت از فروش</option>
                                                        <option value="5">موجودی اول دوره</option>
                                                    </select>
                                                </div>
                                            </div>}
                                            {this.state.data.record.io === 2 && <div className="col-sm-4">
                                                <div className="form-group">
                                                    <label for="invoiceNumber" className="title1">نوع</label>
                                                    <select className="form-control text-center" defaultValue={this.state.data.record.type} onChange={e => this.state.data.record.type = parseInt(e.target.value)}>
                                                        <option value="2">فروش</option>
                                                        <option value="3">برگشت از خرید</option>
                                                    </select>
                                                </div>
                                            </div>}
                                            <div className="col-sm-4">
                                                <div className="form-group">
                                                    <label for="invoiceDate" className="title1">تاریخ<span className="red">*</span></label>
                                                    <DatePicker
                                                        inputReadOnly={true}
                                                        className="form-control input-sm persian-date"
                                                        placeholder={"تاریخ"}
                                                        isGregorian={false}
                                                        showTodayButton={true}
                                                        timePicker={false}
                                                        onChange={(e) => { this.state.data.record.date = e }}
                                                        value={this.getFormatedDateForDatePicker(this.state.data.record.date)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                <div className="form-group">
                                                    <label for="invoiceNumber" className="title1">شماره</label>
                                                    <NumberFormat value={this.state.data.record.number} onChange={e => this.state.data.record.number = parseInt(e.target.value.replace(/,/g, ''))} thousandSeparator={false} prefix={''} className='form-control text-center ltr' />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mr-b-20">
                                    <div className="col-md-12">
                                        <label className="title1">شرح</label>
                                        <textarea className="form-control" type="text" defaultValue={this.state.data.record.description} onChange={e => this.state.data.record.description = e.target.value} />
                                    </div>
                                </div>
                                <table className="table table-bordered">
                                    <thead>
                                        <tr className="active" style={{ "font-size": "9pt", "font-weight": "bold" }}>
                                            <td>#</td>
                                            <td>کالا<span className="red">*</span></td>
                                            <td style={{ "width": "150px" }}>واحد اندازه گیری<span className="red">*</span></td>
                                            <td style={{ "width": "120px" }}>تعداد<span className="red">*</span></td>
                                            <td style={{ "width": "120px" }}>مبلغ واحد <span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span><span className="red">*</span></td>
                                            <td style={{ "width": "120px" }}>جمع کل <span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span></td>
                                            <td></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.data.bodies.sort((a, b) => a.index - b.index).map((item, index) =>
                                            <tr key={item.id} className="accDataEntryGridRow invoice_grid_row" style={{ "font-size": "9pt", "font-weight": "bold" }}>
                                                <td>
                                                    <span className="inGridRowNumber">{(index + 1)}</span>
                                                    <div style={{ "font-size": "9pt", "color": "silver" }}>
                                                        {index > 0 && index != this.state.data.bodies.length - 1 && <span onClick={e => this.upIndex(item.id)} className="fa fa-arrow-up move-up" title="انتقال به بالا"></span>}
                                                        {index < this.state.data.bodies.length - 2 && <span onClick={e => this.downIndex(item.id)} className="fa fa-arrow-down move-down" title="انتقال به پایین"></span>}
                                                    </div>
                                                </td>
                                                <td>
                                                    <SelectAsync
                                                        defaultValue={item.stuffId != this.defaultGuid() ? [{ value: item.stuffId, label: item.stuffName }] : null}
                                                        isMulti={false}
                                                        placeholder="انتخاب آیتم"
                                                        defaultOptions
                                                        loadOptions={this.loadStuffsOptions}
                                                        onChange={e => this.setBodyValue(item.id, 'stuffId',e)}
                                                    />
                                                </td>
                                                <td>
                                                    <SelectAsync
                                                        defaultValue={item.unitId != this.defaultGuid() ? [{ value: item.unitId, label: item.unitName }] : null}
                                                        isMulti={false}
                                                        placeholder="واحد اندازه گیری"
                                                        defaultOptions
                                                        loadOptions={this.loadUnitsOptions}
                                                        onChange={e => this.setBodyValue(item.id,'unitId', e)}
                                                    />
                                                </td>
                                                <td style={{ "width": "80px" }}><NumberFormat value={item.amount} onChange={e => this.setBodyValue(item.id, 'amount', parseFloat(e.target.value.replace(/,/g, '')))} thousandSeparator={false} prefix={''} className='form-control text-center ltr' /></td>
                                                <td style={{ "width": "120px" }}><NumberFormat value={item.price} onChange={e => this.setBodyValue(item.id, 'price', parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={false} prefix={''} className='form-control text-center ltr' /></td>
                                                <td style={{ "width": "120px" }}>
                                                    <NumberFormat readOnly={true} value={item.total} thousandSeparator={false} prefix={''} className='form-control text-center ltr' />
                                                </td>
                                                <td>
                                                    {item.stuffId != this.defaultGuid() && <span title="حذف سطر" onClick={e => this.removeRow(item.id)} className="fa fa-trash fa-fw close-grid-row"></span>}
                                                    {item.stuffId != this.defaultGuid() && <span title="کپی سطر" onClick={e => this.copyRow(item.id)} className="fa fa-copy fa-fw close-grid-row"></span>}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <div className="row" >
                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                        <div className="row mr-t-10">
                                            <div className="col-md-2 ltr text-right">
                                            </div>
                                        </div>
                                        <div className="form-group" >
                                            <label className="title1" for="comment">یادداشت</label>
                                            <textarea onChange={e => this.state.data.record.note = e.target.value} defaultValue={this.state.data.record.note} className="form-control ng-pristine ng-untouched ng-valid" rows="4" maxlength="250"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="panel-footer">
                                <div className="row">
                                    <div className="col-sm-8 text-right">
                                        <button type="button" className="hand btn btn-primary" onClick={e => this.save(e, false)} >ذخیره</button>
                                        {this.state.data.record.io === 2 && <button type="button" className="hand btn btn-warning" onClick={e => this.save(e, false)} style={{ "marginRight":"10px" }} >صدور سند</button>}
                                        &nbsp;
                                        {this.state.data.record.id !== this.defaultGuid() && [
                                            <a className="hand btn btn-default" style={{ "marginRight": "10px" }} onClick={e => this.exportFromUrl('print', '/api/v1/remittance/export/' + this.state.data.record.id)}>
                                                <span className="fa fa-print" aria-hidden="true"></span>&nbsp;
                                                چاپ
                                            </a>
                                            ,
                                            <a className="hand btn btn-default" style={{ "marginRight": "10px" }} onClick={e => this.exportFromUrl('pdf', '/api/v1/remittance/export/' + this.state.data.record.id)}>
                                                <span className="fa fa-file-pdf-o" aria-hidden="true"></span>&nbsp;
                                                PDF
                                            </a>
                                        ]
                                        }
                                    </div>
                                    <div className="col-sm-4 text-left"><a className="btn btn-default btn-smoke" style={{ "width": "80px" }} onClick={e => this.closeMe()}>انصراف</a></div>
                                </div>
                            </div>
                        </div >
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent()
            ];

        return contents;
    }
}